import { getApiClient } from 'apiClient';
import { type AxiosRequestConfig } from 'axios';
import { type CreatedMediaDataObject } from 'models/services';
import { routes } from './routes';

type BodyRequest = {
  checksum: string;
  chunks: Array<{ checksum: string; chunkNumber: number; etag: string }>;
};

type CompleteUploadeResponse = CreatedMediaDataObject;

export const completeUpload = async ({
  body,
  config,
  mediaId,
}: {
  body: BodyRequest;
  config: AxiosRequestConfig;
  mediaId: string;
}) => getApiClient().post<CompleteUploadeResponse>(routes.chunkedUpload.complete(mediaId), body, config);
